import { useTranslation } from 'react-i18next';
import { z } from 'zod';

const PermissionEnum = z.enum(['OWNER', 'ADMIN', 'MANAGER'], {
  errorMap: () => ({ message: 'invalid' }),
});

export type Permission = z.infer<typeof PermissionEnum>;

export const useFormSchema = () => {
  const { t } = useTranslation('translation');

  return z.object({
    permission: PermissionEnum.refine(() => true, {
      message: t('common.formErrors.invalidPermissions'),
    }),
  });
};
